export default __webpack_public_path__ + "static/media/download_appstore_btn-black.27f2cfb9.svg";